const environment = window._environment;
const googleAnalyticsTrackingId = window._googleAnalyticsTrackingId;
const googleTagManagerTrackingId = window._googleTagManagerTrackingId;
const googleApiClientId = window._googleApiClientId;
const merchantId = window._merchantId;



function returnAppConfig() {
  return {
    environment,
    googleAnalyticsTrackingId,
    googleTagManagerTrackingId,
    googleApiClientId,
    isProductionEnvironment: ['stage', 'prod'].includes(environment),
    isTestEnvironment: ['local', 'dev', 'uat'].includes(environment),
    isLocalEnvironment: environment === 'local',
    merchantId
  };
}



export default returnAppConfig;
